/**
 * Lead magnet registry. A blog post points at an entry by `lead_magnet_key`.
 * Browser-safe: the PDF builder is loaded lazily only when a visitor downloads.
 */
export type LeadMagnet = {
  key: string;
  title: string;
  eyebrow: string;
  oneLiner: string;
  /** GHL tags added to the contact on opt-in. */
  tags: string[];
  fileName: string;
  buildPdf: () => Promise<Blob>;
};

export const SMS_CONSENT_TAG = "sms-consent";

export const LEAD_MAGNETS: Record<string, LeadMagnet> = {
  "high-rate-playbook": {
    key: "high-rate-playbook",
    title: "The High-Rate Market Playbook",
    eyebrow: "Free playbook",
    oneLiner: "The data, the buydown conversation and the buyer script, in five pages.",
    tags: ["lead-magnet", "high-rate-playbook"],
    fileName: "high-rate-market-playbook.pdf",
    buildPdf: async () => (await import("@/components/lead-magnets/HighRatePlaybookPdf")).buildHighRatePlaybook(),
  },
};

export const LEAD_MAGNET_KEYS = Object.keys(LEAD_MAGNETS);

export function getLeadMagnet(key: string | null | undefined): LeadMagnet | null {
  return key ? (LEAD_MAGNETS[key] ?? null) : null;
}

export function leadMagnetFormId(key: string) {
  return `lead-magnet:${key}`;
}
